import React from 'react'
import { useSelector } from 'react-redux'
import { selectAdDataByAdId, selectPageIdForAdConfig } from '../../store/ad/ad.selectors'
import { selectHasUserConsentedForNativeAdvertising } from '../../store/cmp/cmp.selectors'
import { isEmptyObj } from '../../utils/object'
import { isPE } from '../Device'
import { TAG_CLICK_CAMPAGNE_PUSH } from '../analytics/analytics.tagids.constants'
import TagActionLink from '../genericComponents/TagActionLink'
import RectangleActionButton, {
  COLOR_GREEN_EMPTY,
  SIZE_MEDIUM
} from '../genericComponents/buttons/RectangleActionButton'
import { useSelectorWithProps } from '../utils/react-redux'
import { getAdIdByAdName } from './AdConfigService'
import AdLoader from './AdLoader'
import s from './PushSponsoBanner.less'
import { useSendExternalTrackingUrl } from './ad.utils'

const PushSponsoBanner = ({ adName }) => {
  const hasUserConsentedForNativeAdvertising = useSelector(selectHasUserConsentedForNativeAdvertising)
  const pageId = useSelector(selectPageIdForAdConfig)
  const adId = getAdIdByAdName(adName, pageId)
  const adData = useSelectorWithProps(selectAdDataByAdId, { adId })
  const { text, linkLabel, imgUrl, linkUrl } = adData || {}

  useSendExternalTrackingUrl(adId)

  if (__SERVER__ || (__BROWSER__ && isPE() && hasUserConsentedForNativeAdvertising)) {
    return (
      <div className={s.container}>
        <AdLoader adName={adName} askData placeHolderHeight={113}>
          {/* previous empty div is mandatory to avoid content to scroll to the top */}
          {!isEmptyObj(adData) && (
            <TagActionLink
              type={TAG_CLICK_CAMPAGNE_PUSH}
              tagInfo={{
                url: imgUrl
              }}
              href={linkUrl}
              targetBlank={true}
              className={s.link}
            >
              <img className={s.logo} src={imgUrl} />
              <div className={s.content}>
                <p className={s.text}>{text}</p>
                <div className={s.button}>
                  <RectangleActionButton label={linkLabel} color={COLOR_GREEN_EMPTY} size={SIZE_MEDIUM} />
                </div>
              </div>
            </TagActionLink>
          )}
        </AdLoader>
      </div>
    )
  }

  return <></>
}

export const PushSponsoBannerPE = () => <PushSponsoBanner adName="hp_pagessponso" />
